// import request from '@/utils/request'
import { get, post,put,remove } from '@/utils/http.js'

// 
// 查询消防设施设置列表
// export function listFireFacilities(query) {
//   return request({
//     url: '/v1/trmoni/fireFacilities/list',
//     method: 'get',
//     params: query
//   })
// }
export const listFireFacilities = (query)=>get('/trmoni/fireFacilities/list',query)

// 查询消防设施设置详细
// export function getFireFacilities(id) {
//   return request({
//     url: '/v1/trmoni/fireFacilities/' + id,
//     method: 'get'
//   })
// }
export const getFireFacilities = (id)=>get('/trmoni/fireFacilities/' + id)

// 新增消防设施设置
// export function addFireFacilities(data) {
//   return request({
//     url: '/v1/trmoni/fireFacilities',
//     method: 'post',
//     data: data
//   })
// }
export const addFireFacilities = (data)=>post('/trmoni/fireFacilities',data)

// 修改消防设施设置
// export function updateFireFacilities(data) {
//   return request({
//     url: '/v1/trmoni/fireFacilities',
//     method: 'put',
//     data: data
//   })
// }

export const updateFireFacilities = (data)=>put('/trmoni/fireFacilities',data)




// export const delFireFacilities = (data)=>get('/trmoni/fireFacilities',data)


// 删除消防设施设置
// export function delFireFacilities(id) {
//   return request({
//     url: '/v1/trmoni/fireFacilities/' + id,
//     method: 'delete'
//   })
// }
export const delFireFacilities = (id)=>remove('/trmoni/fireFacilities/' + id)

// 导出消防设施设置
// export function exportFireFacilities(query) {
//   return request({
//     url: '/v1/trmoni/fireFacilities/export',
//     method: 'get',
//     params: query
//   })
// }
export const exportFireFacilities = (query)=>get('/trmoni/fireFacilities/export' + query)
